import React from 'react';
import { observer } from 'mobx-react';
import { Loader, Progress, Button } from 'semantic-ui-react';
import _ from 'lodash';
import ReactTimeago from 'react-timeago';

import { Modal } from '#/ssm-ui/Modal';
import { useStores, useStore } from '#/shared/hooks/useStores';
import { humanizeDuration } from '#/utils/date';

const AgendaProgressLoadingModal = observer(({ isOpen, message }) => {
  const store = useStore('agendaJobProgress');
  const {
    ui: { agendaProgressLoadingModal: modalStore },
  } = useStores();

  const agendaJobProgressObj = store.selected;

  return (
    <Modal
      className="ssm-content"
      dimmer="blurring"
      onClose={() => {
        if (
          !_.isEmpty(agendaJobProgressObj) &&
          agendaJobProgressObj.progress >= 100
        ) {
          modalStore.close();
        }
      }}
      open={isOpen}
      size="small"
      style={{
        backgroundColor: '#FFFFFFCC',
        zIndex: 2000,
      }}
    >
      <Modal.Header>
        {message}:{' '}
        {agendaJobProgressObj.status === 'running' ? (
          <span>
            Waiting for {agendaJobProgressObj?.jobName || 'Job'} to Complete
          </span>
        ) : (
          <span>
            {_.capitalize(agendaJobProgressObj.status)}{' '}
            {agendaJobProgressObj.errorMsg ? 'with errors' : ''}
          </span>
        )}
      </Modal.Header>
      <Modal.Content className="max-vh-75 overflow-y-scroll">
        {!_.isEmpty(agendaJobProgressObj) ? (
          <div className="ph4">
            <Progress
              indicating={true}
              label={
                <span>
                  Elapsed:{' '}
                  {agendaJobProgressObj.status === 'running' ? (
                    <ReactTimeago
                      date={modalStore.openedAt}
                      formatter={(value, unit) => {
                        return `${value} ${unit}${value > 1 ? 's' : ''}`;
                      }}
                    />
                  ) : (
                    `Total Time: ${humanizeDuration(
                      modalStore.openedAt,
                      agendaJobProgressObj.updatedAt,
                    )}`
                  )}
                </span>
              }
              percent={agendaJobProgressObj.progress}
              progress="percent"
              success={agendaJobProgressObj.progress === 100}
            />
            <div className="w-100 tc">
              {agendaJobProgressObj.completedTasks &&
                agendaJobProgressObj.completedTasks.length > 0 && (
                  <div className="mt3">
                    <div className="mb2">
                      <span className="tw-font-bold">Completed Tasks:</span>
                    </div>
                    <ul className="list-style-none pa0 ma0">
                      {_.map(agendaJobProgressObj.completedTasks, (task) => (
                        <li className="mb1" key={task}>
                          {task}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              {agendaJobProgressObj.errorMsg && (
                <div className="mt3">
                  <div className="red tw-font-bold">Error:</div>
                  <ul className="list-style-none pa0 ma0">
                    {agendaJobProgressObj.errorMsg
                      .split('; ')
                      .map((error, index) => (
                        <li className="red mb1" key={index}>
                          {error}
                        </li>
                      ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="ph4 pv4">
            <Loader active={true} />
            <div className="w-100 tc pt3">{message}</div>
          </div>
        )}
      </Modal.Content>
      <Modal.Actions>
        {agendaJobProgressObj?.status === 'running' ? (
          <Button
            basic={true}
            onClick={() => modalStore.completeInBackground()}
          >
            Complete in Background
          </Button>
        ) : (
          <Button onClick={() => modalStore.close()} primary={true}>
            Close
          </Button>
        )}
      </Modal.Actions>
    </Modal>
  );
});

export default AgendaProgressLoadingModal;
